import { createAction } from '@ngrx/store';

const loadOffers = createAction('[Offer List Component] Load offers');

export const OfferListActions = {
  loadOffers,
};
